import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';

const IconSleekSilhouetteSofa = ({
  color = colorGray,
  width = '48',
  height = '48',
  className = '',
}) => {
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="216.6"
      y="916.6"
      width="3.8"
      height="10.8"
      rx="1.4"
      stroke={color}
      strokeWidth="1.2"
    />
    <rect
      x="227.6"
      y="920.6"
      width="15.8"
      height="6.8"
      rx="1.4"
      stroke={color}
      strokeWidth="1.2"
    />
    <rect
      x="220.6"
      y="913.6"
      width="6.8"
      height="12.8"
      rx="1.4"
      stroke={color}
      strokeWidth="1.2"
    />
    <rect
      x="216.6"
      y="925.6"
      width="29.8"
      height="12.8"
      rx="1.4"
      fill="white"
      stroke={color}
      strokeWidth="1.2"
    />
    <rect
      x="8.6"
      y="14.6"
      width="3.8"
      height="10.8"
      rx="1.4"
      stroke={color}
      strokeWidth="1.2"
    />
    <rect
      x="19.6"
      y="18.6"
      width="15.8"
      height="6.8"
      rx="1.4"
      stroke={color}
      strokeWidth="1.2"
    />
    <rect
      x="12.6"
      y="11.6"
      width="6.8"
      height="12.8"
      rx="1.4"
      stroke={color}
      strokeWidth="1.2"
    />
    <rect
      x="8.6"
      y="23.6"
      width="29.8"
      height="12.8"
      rx="1.4"
      fill="white"
      stroke={color}
      strokeWidth="1.2"
    />
  </svg>;
};

IconSleekSilhouetteSofa.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
};

export default IconSleekSilhouetteSofa;
